// Libraries & Polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// Stylesheet
import "./salbase.scss"
// Tracking Setup
import "./utilities/sal-usercentrics/sal-usercentrics";
import "./_tagmanager";
import "./_tracking-setup";

// Always loaded Project Modules
import {cookieUtils} from '@utilities/cookie-utils/cookie-utils';
import {fullscreenmodal} from "@utilities/sal-fullscreenmodal/sal-fullscreenmodal";
import {bookingmodal} from "@utilities/sal-bookingmodal/sal-bookingmodal";
import {commentator} from "@utilities/sal-commentator/sal-commentator"
import lazyloader from '@utilities/sal-lazyload/sal-lazyload'
import {Lightbox} from '@utilities/sal-lightbox/sal-lightbox';
import {languagemenu} from './Resources/salbase9/Partials/Page/global-languagemenu';
import {tooltip} from "@global/global-elements/global-tooltip/global-tooltip";
import {Navigation} from './Resources/salbase9/Partials/Page/global-navigation';
import {globalQuicksearch} from './Resources/salbase9/Partials/Page/global-quicksearch';
import {IconMenu} from './Resources/salbase9/Partials/Page/global-icon-menu';
import {Quicklinks, QuicklinkTab} from './Resources/salbase9/Partials/Page/global-quicklinks';
import {shopUtilities} from '@global/shop-utilities/shop-utilities';
import '@global/global-forms';
import {embedguardLoader} from '@global/global-elements/global-embedguard/embedguard-loader';
import {linkreplacer} from '@utilities/sal-linkreplacer/sal-linkreplacer.ts';
import {globalAbbreviation} from "@global/utilities/global-abbreviation";
// EWContact + EWCareer
import './thirdparty/ewcareer/ewcareer';
import './thirdparty/ewcontact/ewcontact';
import {globalIframeClickHandler} from "@global/utilities/global-iframe-click-handler";

window.VIDEOJS_NO_DYNAMIC_STYLE = true

globalIframeClickHandler()

// Autmated Testing support
window["IS_AUTOMATED_TESTING"] = document.cookie.includes('automated_testing');

// On Demand included Project Modules
if (document.getElementById('dealer-search') !== null) {
    import ('./Resources/salbase9/Templates/DealerSearch'/* webpackChunkName: "tools" */).then(({dealersearch}) => {
        dealersearch.init();
    });
}

if (document.getElementById('global-search') !== null) {
    import ('./Resources/salbase9/Templates/Search'/* webpackChunkName: "global" */).then(({globalsearch}) => {
        globalsearch.init();
    });
}

if (document.querySelector(`.global-download`) !== null) {
    import('@global/global-elements/global-download/global-download.js'/* webpackChunkName: "products" */).then(({globalDownload}) => {
        globalDownload.init("global-download");
    });
}

if (document.querySelector(`.tabs-with-image`) !== null) {
    import('./global/global-elements/global-tabs-with-image/global-tabs-with-image'/* webpackChunkName: "global" */).then(({tabsWithImages}) => {
        tabsWithImages.initToggle();
        tabsWithImages.initTabs();
    });
}

if (document.getElementById('product-finder') !== null) {
    import("./Resources/epim/Templates/ProductFinder"/* webpackChunkName: "products" */).then(({productFinder}) => {
        productFinder.init();
    });
}

if (document.querySelector('.step-process') !== null) {
    import("./Resources/salbase9/Templates/ContentElements/StepProcess"/* webpackChunkName: "stepProcess" */).then(({stepProcess}) => {
        stepProcess.init();
    });
}

if (document.querySelector('.video-keyvisual__wrapper') !== null) {
    import("./Resources/salbase9/Templates/ContentElements/VideoKeyvisual"/* webpackChunkName: "videoKeyvisual" */).then(({videoKeyvisual}) => {
        videoKeyvisual.init();
    });
}

if (document.getElementById('shop-wish-cart') !== null) {
    import("./Resources/epim/Templates/WishCart"/* webpackChunkName: "shop" */).then(({shopCheckout}) => {
        shopCheckout.init();
    });
}

if (document.getElementById('moodboard') !== null) {
    import("./Resources/epim/Templates/Moodboard"/* webpackChunkName: "moodboard" */).then(({moodboardInit}) => {
        moodboardInit.init()
    });
}

if (document.querySelector('.inline-3d__app') !== null) {
    import("./Resources/epim/Templates/ContentElements/Inline3d"/* webpackChunkName: "inline3d" */).then(({inline3dInit}) => {
        inline3dInit.init()
    });
}

if (document.getElementById('dealer-request') !== null) {
    import("./Resources/epim/Templates/DealerRequest"/* webpackChunkName: "dealerrequest" */).then(({dealerRequestInit}) => {
        dealerRequestInit.init()
    });
}

if (document.getElementById('endproduktfinder') !== null) {
    import("./Resources/epim/Partials/PimEndproduktFinder/"/* webpackChunkName: "endproduktfinder" */).then(({endproduktFinderInit}) => {
        endproduktFinderInit.init();
    })
}

if (document.querySelector(`.global-material-tile`) !== null) {
    import("@global/global-elements/global-material-tile/global-material-tile"/* webpackChunkName: "global" */).then(({globalMaterialTile}) => {
        globalMaterialTile.init("global-material-tile");
    });
}

if (document.querySelector('.ave__container') !== null) {
    import('./Resources/epim/Templates/AvailabilityEntrypage/'/* webpackChunkName: "global" */).then(({availabilityEntrypageInit}) => {
        try {
            availabilityEntrypageInit.init();
        } catch (e) {
            if (document.location.hostname.includes('ddev')) console.error(e);
            commentator.insertCommentBefore(document.body, 'salbase.js: ' + e, commentator.getPresets().ERROR);
        }
    });
}

if (document.querySelector('.greentool__container') !== null) {
    import('./Resources/epim/Templates/Greentool/'/* webpackChunkName: "global" */).then(({greentoolInit}) => {
        try {
            greentoolInit.init();
        } catch (e) {
            if (document.location.hostname.includes('ddev')) console.error(e);
            commentator.insertCommentBefore(document.body, 'salbase.js: ' + e, commentator.getPresets().ERROR);
        }
    });
}

if (document.querySelector('.references-entrypage') !== null) {
    import('./global/global-elements/global-gallery/global-gallery'/* webpackChunkName: "global" */).then(({globalGallery}) => {
        try {
            // FIXME globalGallery is not multi instance ready
            globalGallery.init(".references-entrypage", "references-entrypage__gallery");
        } catch (e) {
            if (document.location.hostname.includes('ddev')) console.error(e);
            commentator.insertCommentBefore(document.body, 'salbase.js: ' + e, commentator.getPresets().ERROR);
        }
    })
}

if (document.querySelector('.global-gallery') !== null) {
    import('./global/global-elements/global-gallery/global-gallery'/* webpackChunkName: "global" */).then(({globalGallery}) => {
        try {
            // FIXME globalGallery is not multi instance ready
            globalGallery.init(".global-gallery", "global-gallery__wrapper");
        } catch (e) {
            if (document.location.hostname.includes('ddev')) console.error(e);
            commentator.insertCommentBefore(document.body, 'salbase.js: ' + e, commentator.getPresets().ERROR);
        }
    })
}

if (document.querySelector('.global-gallery-slider') !== null) {
    import('./global/global-elements/global-gallery-slider/global-gallery-slider'/* webpackChunkName: "global" */).then(({globalGallerySlider}) => {
        try {
            document.querySelectorAll('.global-gallery-slider').forEach((gallery) => {
                globalGallerySlider(gallery)
            })
        } catch (e) {
            if (document.location.hostname.includes('ddev')) console.error(e);
            commentator.insertCommentBefore(document.body, 'salbase.js: ' + e, commentator.getPresets().ERROR);
        }
    })
}

if (document.querySelector(`.reference-list__item`) !== null) {
    import('./Resources/epim/Partials/reference-list.js'/* webpackChunkName: "products" */).then(({loadmore}) => {
        loadmore.init({});
    });
}

if (document.querySelector(`.entity-list-vertical--container`)) {
    import('./Resources/epim/Partials/entity-list-vertical.js'/* webpackChunkName: "global" */).then(({verticalList}) => {
        verticalList.init({});
    });
}

if (document.querySelector(`.reference-detail`) !== null) {
    import('./Resources/epim/Templates/ReferenceDetailpage/reference-detail.js'/* webpackChunkName: "products" */).then(({referenceDetail}) => {
        referenceDetail.init({});
    });
}

if (document.querySelector('.layout-content-navigation') || document.querySelector('.news__detail')) {
    import('./Resources/salbase9/Templates/Page/landingpage'/* webpackChunkName: "global" */).then(({landingpage}) => {
        landingpage.init();
    });
}

if (document.querySelector('.global-tile') || document.querySelector('.news-list-view--tiles')) {
    import('./global/global-elements/global-tile/global-tile'/* webpackChunkName: "global" */).then(({tileSlider}) => {
        const globalTileElement = document.querySelector('.global-tile');
        if (globalTileElement !== null) {
            tileSlider.init();
        }

        const newsElement = document.querySelector('.news-list-view--tiles');
        if (newsElement !== null) {
            tileSlider.init({
                sliderClass: "news-list-view--tiles",
                slideClass: "news__item--tile",
                activeClass: "slide--active",
                sliderActivatedClass: "slider--initialized",
                touchArea: "news-list-view--tiles",
                threshold: 200
            })
        }
    });
}

if (document.querySelector('.pagination') !== null) {
    import('./Resources/salbase9/Templates/News/news-loadmore'/* webpackChunkName: "global" */).then(({loadmore}) => {
        loadmore.init({});
    });
}

if (document.querySelector('.pageoverview') !== null) {
    import('./Resources/salbase9/Templates/PageOverview/pageoverview'/* webpackChunkName: "magazin" */).then(({pageoverview}) => {
        pageoverview.init();
    });
}

// Bullshit... Wieso sind die ganzen Klassen in den Modulen mit Konstanten definiert nur um dann hier nochmal ohne Konstante zu stehen...
// Vlt. sollte man lieber ne Zentrale Konstanten-Library machen die man dann auch hier benutzen kann.
// Ausserdem natürlich der Quatsch, dass die filter-list keine Klasse "aussenrum" hat
if (document.querySelector('*:not(.global-filter-list--vue) > .filter__head') !== null) {
    import('./global/global-elements/global-filter-list/global-filter-list.js'/* webpackChunkName: "global" */).then(({dropdown}) => {
        dropdown.init();
    });
}

if (document.querySelector('.global-tabs--js') !== null) {
    import('./global/global-elements/global-tabs/global-tabs.js'/* webpackChunkName: "global" */).then(({tabs}) => {
        tabs.init();
    });
}

if (document.querySelector('.accordion') !== null) {
    import('./Resources/salbase9/Layouts/ContentElements/accordion'/* webpackChunkName: "global" */).then(({accordion}) => {
        accordion.init();
    });
}

if (document.querySelector('.product-detail') !== null) {
    import('./Resources/epim/Templates/ProductDetailpage/product-detail.js'/* webpackChunkName: "products" */).then(({productDetail}) => {
        productDetail.init({});
    });
}

import('./Resources/salbase9/Partials/Page/global-flyout'/* webpackChunkName: "global" */).then(({GlobalFlyout}) => {
    const flyoutElement = document.querySelector('.global-flyout');
    if (flyoutElement !== null) {
        const flyout = new GlobalFlyout();
        flyout.init({namespace: 'global-flyout'});
    }
});

import('./Resources/salbase9/Partials/Page/global-scroll-top'/* webpackChunkName: "global" */).then(({scrollTop}) => {
    const scrollButton = document.querySelector('.scroll-top');
    if (scrollButton !== null) {
        scrollTop.init({scrollButtonClass: "scroll-top"});
    }
});

import('./Resources/salbase9/Partials/Page/global-product-combo-panel'/* webpackChunkName: "global" */).then(({globalProductComboPanel}) => {
    const globalProductComboPanelReference = document.querySelector('.global-product-combo-panel');
    if (globalProductComboPanelReference !== null) {
        globalProductComboPanel.init({});
    }
});

if (document.querySelector('.gallery') !== null) {
    import('./Resources/salbase9/Partials/ContentElements/Media/gallery'/* webpackChunkName: "global" */).then(({gallery}) => {
        gallery.init();
    });
}

if (document.querySelector(".decor-comparison") !== null) {
    import('./Resources/epim/Partials/PimDecorComparison/pim-decor-comparison'/* webpackChunkName: "products" */).then(({decorComparison}) => {
        decorComparison.init();
    });
}

//if (document.querySelector('.open-three-d')) {
import('@utilities/sal-three-viewer/loader'/* webpackChunkName: "global" */).then(({loader}) => {
    loader.init();
});
//}

if (document.querySelector('.popup') !== null) {
    import('./Resources/salbase9/Templates/ContentElements/Popup/popup').then(({popup}) => {
        popup.init();
    })
}

if (document.querySelector('.constructionstage') !== null) {
    import('./Resources/epim/Templates/ContentElements/Constructionstage/constructionstageinit'/* webpackChunkName: "industry" */).then(({constructionstageinit}) => {
        try {
            constructionstageinit.init();
        } catch (e) {
            if (document.location.hostname.includes('ddev')) console.error(e);
            commentator.insertCommentBefore(document.body, 'salbase.js: ' + e, commentator.getPresets().ERROR);
        }
    });
}

if (document.querySelector('.producttable') !== null) {
    import('./Resources/epim/Templates/ContentElements/Producttable/producttable'/* webpackChunkName: "industry" */).then(({producttable}) => {
        try {
            producttable.init();
        } catch (e) {
            if (document.location.hostname.includes('ddev')) console.error(e);
            commentator.insertCommentBefore(document.body, 'salbase.js: ' + e, commentator.getPresets().ERROR);
        }
    });
}

if (document.querySelector('.solutionguide') !== null) {
    import('./Resources/epim/Templates/SolutionGuide/solutionguideinit'/* webpackChunkName: "industry" */).then(({solutionguideinit}) => {
        try {
            solutionguideinit.init();
        } catch (e) {
            if (document.location.hostname.includes('ddev')) console.error(e);
            commentator.insertCommentBefore(document.body, 'salbase.js: ' + e, commentator.getPresets().ERROR);
        }
    });
}

if (document.querySelector('.media-gallery__container') !== null) {
    import('./Resources/epim/Templates/MediaGallery/index'/* webpackChunkName: "mediagallery" */).then(({mediaGalleryInit}) => {
        try {
            mediaGalleryInit.init();
        } catch (e) {
            if (document.location.hostname.includes('ddev')) console.error(e);
            commentator.insertCommentBefore(document.body, 'salbase.js: ' + e, commentator.getPresets().ERROR);
        }
    });
}

if (document.querySelector('.global-newsletter-banner') !== null) {
    import('./Resources/salbase9/Partials/Page/global-newsletter-banner'/* wepackChunkName: "global" */).then(({banner}) => {
        try {
            banner.init();
        } catch (err) {
            console.error(err)
        }
    })
}

if (document.querySelector('.global-newsletter-registration') !== null) {
    import('@global/global-elements/global-newsletter-registration/global-newsletter-registration-init'/* wepackChunkName: "global" */).then(({registration}) => {
        try {
            registration.init();
        } catch (err) {
            console.error(err)
        }
    })
}

if (document.querySelector('.ce-social-media-embed') !== null) {
    import('./Resources/salbase9/Templates/ContentElements/SocialMediaEmbed/social-media-embed'/* webpackChunkName: "social" */).then(({socialMediaEmbed}) => {
        try {
            socialMediaEmbed.init();
        } catch (err) {
            console.error(err)
        }
    })
}

const pimContentNavigations = document.querySelectorAll('.content-navigation')
if (pimContentNavigations !== null) {
    import('./Resources/epim/Partials/PimContentNavigation/pim-content-navigation'/* webpackChunkName: "products" */).then(({pimContentNavigation}) => {
        pimContentNavigation(pimContentNavigations)
    })
}

const pimTabs = document.querySelectorAll('.pim-tabs')
if (pimTabs !== null) {
    import('./Resources/epim/Partials/pim-tabs'/* webpackChunkName: "products" */).then(({tabNavigation}) => {
        tabNavigation(pimTabs)
    })
}

const GlobalSimpleSlider = document.querySelector('.global-simple-slider')
if (GlobalSimpleSlider !== null) {
    import('@src/Resources/salbase9/Partials/ContentElements/Global/GlobalSimpleSlider/global-simple-slider'/* webpackChunkName: "global" */).then(({globalSimpleSlider}) => {
        globalSimpleSlider("global-simple-slider")
    })
}

const pimProductTableListElements = document.querySelectorAll('.pim-product-table-list')
if (pimProductTableListElements !== null) {
    import('./Resources/epim/Partials/PimProductTableList/pim-product-table-list' /* webpackChunkName: "products" */).then(({productTableList}) => {
        productTableList(pimProductTableListElements)
    })
}

const pimImageListItems = document.querySelectorAll('.imagelist--image')
if (pimImageListItems !== null) {
    import('./Resources/epim/Partials/pim-image-list' /* webpackChunkName: "products" */).then(({pimImageList}) => {
        pimImageList(pimImageListItems)
    })
}

document.addEventListener("DOMContentLoaded", () => {
    globalQuicksearch.init();
    shopUtilities.init();
    globalAbbreviation();

    languagemenu(`.global-header--large .languagemenu`);
    languagemenu(`.global-header--medium .languagemenu`);
    const lgNav = new Navigation();
    lgNav.init('global-header--large');

    const lgIconMenu = new IconMenu();
    lgIconMenu.init({namespace: 'global-header--large'});

    const mdNav = new Navigation();
    mdNav.init('global-header--medium');

    const mdIconMenu = new IconMenu();
    mdIconMenu.init({namespace: 'global-header--medium'});

    const lgQuicklinks = new QuicklinkTab();
    lgQuicklinks.init({namespace: 'global-header--large'});

    const mdQuicklinks = new Quicklinks();
    mdQuicklinks.init({namespace: 'global-header--medium'});


    // rootmargin extends the intersecting area --> images are loaded even if they are not in the view yet.
    lazyloader.init('sal-image', {root: null, rootMargin: '300px', threshold: 0.0});

    const galleryWithLightbox = document.querySelector('.lightbox');
    if (galleryWithLightbox) {
        new Lightbox({mode: 'gallery'});
        new Lightbox({mode: 'single'});
        new Lightbox({mode: 'grid'});
    }

    fullscreenmodal.init();
    bookingmodal.init();

    tooltip.init();
    tooltip.registerGlobalListener();

    embedguardLoader.init();

    // Save market and language for coming back from room designer
    cookieUtils.setCookie('rd_m', window.market, 0, true, true, 0);
    cookieUtils.setCookie('rd_l', window.language, 0, true, true, 0);

    linkreplacer.init([
        // Make sure to only pass TEXT nodes as the content will be replaced
        {selector: 'form .input.checkbox label.form-check-label span', newWindow: true}
    ]);
});


